import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, Button, Dialog, Divider, DialogTitle, DialogContent, DialogContentText, DialogActions, Checkbox, CircularProgress} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import {db} from '../../firebaseConfig';

import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import AdoptionFollowUpInputModal from './AdoptionFollowUpInputModal';
import AdoptionFollowUpDrawerModal from './AdoptionFollowUpDrawerModal';
import { tokens } from '../../theme';
import Header from '../../components/Header';
import { IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import { logToast } from '../../common/ToastMessageLogger';

import noRecordImage from './no_adoptionfollowups.png'; //All Lowercase with underscore

import Tile from './AdoptionFollowUpTile';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";


    const generateAdoptionColorMap = (adoptionFollowUps, adoptionMap,theme) => {

    const adoptionIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    adoptionFollowUps.forEach(adoptionFollowUp => {
        if (!adoptionIdColorMap[adoptionFollowUp.adoptionId]) {
        adoptionIdColorMap[adoptionFollowUp.adoptionId] = colorFunction(adoptionFollowUp.adoptionId);
        }
    });
    
    return adoptionIdColorMap;
    };
    
const generateFollowUpStatusColorMap = (adoptionFollowUps,theme) => {
  
        const followUpStatusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        adoptionFollowUps.forEach(adoptionFollowUp => {
          if (!followUpStatusColorMap[adoptionFollowUp.followUpStatus]) {
            followUpStatusColorMap[adoptionFollowUp.followUpStatus] = colorFunction(adoptionFollowUp.followUpStatus);
          }
        });
      
        return followUpStatusColorMap;
      };
      
const generateContactMethodColorMap = (adoptionFollowUps,theme) => {
  
        const contactMethodColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        adoptionFollowUps.forEach(adoptionFollowUp => {
          if (!contactMethodColorMap[adoptionFollowUp.contactMethod]) {
            contactMethodColorMap[adoptionFollowUp.contactMethod] = colorFunction(adoptionFollowUp.contactMethod);
          }
        });
      
        return contactMethodColorMap;
      };
      

    const generateVolunteerColorMap = (adoptionFollowUps, volunteerMap,theme) => {

    const volunteerIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    adoptionFollowUps.forEach(adoptionFollowUp => {
        if (!volunteerIdColorMap[adoptionFollowUp.volunteerId]) {
        volunteerIdColorMap[adoptionFollowUp.volunteerId] = colorFunction(adoptionFollowUp.volunteerId);
        }
    });
    
    return volunteerIdColorMap;
    };
    
 

const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  return stringToColorLight(str);
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const formatFirestoreDate = timestamp => {

  if (timestamp != null && timestamp !== "")
  {
    const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
    const parts = dateStr.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  } else 
  {
    return "";
  }
};

const formatFirestoreTime = timestamp => {

 if (timestamp != null && timestamp !== "")
 { 
      // Convert the seconds since Unix epoch to a Date object
    const date = new Date(timestamp.seconds * 1000);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format hours and minutes as a time string in "hh:mm AM/PM" format
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${period}`;
 } else
 {
  return "";
 }
};


const formatPhoneNumber = value => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = value => {

  if (value != null && value !=="")
  {
    return `$${Number(value).toLocaleString()}`;
  } else 
  {
    return "";
  }
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};



const ItemType = {
  CARD: 'card',
};

const DraggableCard = ({ adoptionFollowUp, index, moveCard, followUpStatus, setEditingAdoptionFollowUp, setDeleteId, setConfirmOpen, adoptionFollowUps, setShowModal, colors,theme,deleteSelectionModel,setDeleteSelectionModel,setEditingData,handleDeleteSingleItem,setDrawerOpen ,adoptionMap, formatAdoption,adoptionColorMap,followUpStatusColorMap,contactMethodColorMap,volunteerMap, formatVolunteer,volunteerColorMap }) => {
  const [, ref] = useDrag({
    type: ItemType.CARD,
    item: { id: adoptionFollowUp.id, index, followUpStatus },
  });

    const handleDeleteSelectionChange = (id) => {
   
      setDeleteSelectionModel((prev) =>
        prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
      );
  };



  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();  // Stop the event propagation
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => { setAnchorEl(null); setEditingAdoptionFollowUp(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingAdoptionFollowUp(adoptionFollowUps.find(adoptionFollowUp => adoptionFollowUp.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const adoptionFollowUpToEdit = adoptionFollowUps.find(adoptionFollowUp => adoptionFollowUp.id === id);
      const clonedAdoptionFollowUp = { ...adoptionFollowUpToEdit, id: null, name: `${adoptionFollowUpToEdit.name} CLONED` };
      setEditingAdoptionFollowUp(clonedAdoptionFollowUp);
      setShowModal(true);
    };

    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} /> Clone Adoption Follow Up</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Adoption Follow Up</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Adoption Follow Up</MenuItem>
        </Menu>
      </>
    );
  };
  
  const handleEditAction = (id) => { setEditingAdoptionFollowUp(adoptionFollowUps.find(adoptionFollowUp => adoptionFollowUp.id === id)); setShowModal(true); };

  const handleOpenDrawer = (id) => {
  
    setEditingData(adoptionFollowUps.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(true);
    setShowModal(false);

  };

  return (
    <Card ref={ref} sx={{marginBottom: 2,backgroundColor: colors.dragAndDropDrop.tileBackgroundColor,marginLeft: '9px',marginRight: '9px',
      '&:hover': {
        backgroundColor: colors.dragAndDropDrop.tileBackgroundColorHover, 
      },
    }}
    >
      <CardContent>
  
      <Typography variant="h5" sx={{fontWeight:'800', cursor: 'pointer' }}  onClick={() => handleEditAction(adoptionFollowUp.id)}>{formatAdoption(adoptionFollowUp.adoptionId)}</Typography>
       

        <table style={{width:'100%'}}>
          <tr>
            <td> 
            <Typography variant="h7" sx={{fontWeight:'500', cursor: 'pointer', color:'#898580' }}  onClick={() => handleEditAction(adoptionFollowUp.id)}>{adoptionFollowUp.adoptionFollowUpNumber}</Typography>
            </td>
            <td>  
              <span style={{float:"right"}}>
              <IconButton onClick={() => handleOpenDrawer(adoptionFollowUp.id)}>
                  <KeyboardDoubleArrowRightIcon/>
              </IconButton>
              </span>
            </td></tr></table>
          

        <Typography variant="body2" sx={{paddingTop:'5px',paddingBottom:'5px'}}>{adoptionFollowUp.notes.length > 200 ? adoptionFollowUp.notes.substring(0, 200) + '...' : adoptionFollowUp.notes}</Typography>
        
        <table style={{width:'100%'}} cellSpacing={10}>
          <tr>
            <td style={{borderBottom: '1px solid #626262'}}>
              CONTACT METHOD
            </td>
            <td style={{borderBottom: '1px solid #626262'}}>
              VOLUNTEER
            </td>
          </tr>
          <tr>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={adoptionFollowUp.contactMethod}
                                sx={{ 
                                    backgroundColor: contactMethodColorMap[adoptionFollowUp.contactMethod], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { adoptionFollowUp.contactMethod }

                                </Box>
                    </Typography>

            </td>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box sx={{ backgroundColor: volunteerColorMap[adoptionFollowUp.volunteerId], borderRadius: '13px', padding: '2px 8px',marginBottom: '4px',display: 'inline-block', color: theme.palette.mode === "dark" ? '#000000' : '#000000',fontWeight:'600'  }}>
                            {volunteerMap[adoptionFollowUp.volunteerId]}
                        </Box>
                        </Typography>

            </td>
          </tr>
        </table>

        <div style={{textAlign:'center'}}>
         <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={adoptionFollowUp.followUpStatus}
                                sx={{ 
                                    backgroundColor: followUpStatusColorMap[adoptionFollowUp.followUpStatus], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { adoptionFollowUp.followUpStatus }

                                </Box>
                    </Typography>

        </div>

        <Box sx={{ padding: '0px', margin: '0px', height: '5px' }}>
              <div style={{ float: 'left' }}>

              <Checkbox 
              checked={deleteSelectionModel.includes(adoptionFollowUp.id)}
              onChange={() => handleDeleteSelectionChange(adoptionFollowUp.id)}
                                    
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />

              </div>
        </Box>     
        <Box sx={{ padding: '0px', margin: '0px', height: '20px' }}>

              <div style={{ float: 'right' }}>
                <GridActionsCellItem {...adoptionFollowUp} />
              </div>
        </Box>
      </CardContent>
    </Card>
  );
};


const AdoptionFollowUps = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [adoptionFollowUps, setAdoptionFollowUps] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingAdoptionFollowUp, setEditingAdoptionFollowUp] = useState(null);
  const [loading, setLoading] = useState(true);

  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  const [scheduled, setScheduled] = useState([]);
const [completed, setCompleted] = useState([]);
const [missed, setMissed] = useState([]);


  const [deleteId, setDeleteId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [processing, setProcessing] = useState(false);
  
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [selectedAdoptionFollowUp, setSelectedAdoptionFollowUp] = useState(null);

  const tilesDisplayCount = 6;

  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);

  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  const [adoptionMap, setAdoptionMap] = useState({});
const [volunteerMap, setVolunteerMap] = useState({});


  const [adoptionColorMap, setAdoptionColorMap] = useState({});
const [followUpStatusColorMap, setFollowUpStatusColorMap] = useState({});
const [contactMethodColorMap, setContactMethodColorMap] = useState({});
const [volunteerColorMap, setVolunteerColorMap] = useState({});


  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const adoptionSnapshot = await getDocs(query(collection(db, "adoptions"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const adoptionData = adoptionSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const adoptionMap = adoptionData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.adopterFirstName+ " " +ref.adopterLastName+ " " +ref.petId }), {});
	setAdoptionMap(adoptionMap);

	const volunteerSnapshot = await getDocs(query(collection(db, "volunteers"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const volunteerData = volunteerSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const volunteerMap = volunteerData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName+ " " +ref.lastName }), {});
	setVolunteerMap(volunteerMap);



            if (adoptionData.length === 0 || volunteerData.length === 0) {
	let missing = [];
	if (adoptionData.length === 0) missing.push("adoptions");
	if (volunteerData.length === 0) missing.push("volunteers");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}

        };
    
        fetchStaticData();
      }, [appUserAccountNumber, applicationMode]);
    
    

  const columns = [
	{ field: "adoptionId", headerName: "Adoption"},
	{ field: "followUpDate", headerName: "Follow-Up Date"},
	{ field: "followUpStatus", headerName: "Status"},
	{ field: "notes", headerName: "Notes"},
	{ field: "contactMethod", headerName: "Contact Method"},
	{ field: "outcome", headerName: "Outcome"},
	{ field: "volunteerId", headerName: "Volunteer"},
	{ field: "adoptionFollowUpNumber", headerName: "adoptionFollowUpNumber"},
	{ field: "id", headerName: "id"},
];



  useEffect(() => {

      if (!appUserAccountNumber) return; // Ensure appUserAccountNumber is available

      const adoptionFollowUpsRef = collection(db, "adoptionFollowUps");
      const adoptionFollowUpsQuery = query(adoptionFollowUpsRef, 
        where("appAccountNumber", "==", appUserAccountNumber),
        where("applicationMode", "==", applicationMode)
      );
    
      const unsubscribe = onSnapshot(adoptionFollowUpsQuery, (snapshot) => {
        const adoptionFollowUpsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setAdoptionFollowUps(adoptionFollowUpsData);
    
      /*
      const filteredAdoptionFollowUps = adoptionFollowUpsData.filter(adoptionFollowUp =>
        columns.some(column => adoptionFollowUp[column.field] && adoptionFollowUp[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      */

      const filteredAdoptionFollowUps = adoptionFollowUpsData.filter(adoptionFollowUp =>
        columns.some(column => {
            let value = adoptionFollowUp[column.field];
    
            let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

            if (matchFound == false)
            {
              if (column.field.endsWith('Id')) {
                  const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
    
                  try
                  {
                    value = eval(`${formatFunctionName}("${value}")`);
                    matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
                  } catch(errr){}
              }
            }
    
            return matchFound;
    
        })
      );

      setScheduled(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Scheduled'));
setCompleted(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Completed'));
setMissed(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Missed'));


      setAdoptionColorMap(generateAdoptionColorMap(adoptionFollowUpsData, adoptionMap,theme));
setFollowUpStatusColorMap(generateFollowUpStatusColorMap(adoptionFollowUpsData,theme));
setContactMethodColorMap(generateContactMethodColorMap(adoptionFollowUpsData,theme));
setVolunteerColorMap(generateVolunteerColorMap(adoptionFollowUpsData, volunteerMap,theme));


      setLoading(false);
    }, (error) => {
      setLoading(false);
      alert("Error fetching adoptionfollowups: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber,applicationMode]);

  useEffect(() => {
   
    /*
    const filteredAdoptionFollowUps = adoptionFollowUps.filter(adoptionFollowUp =>
      columns.some(column => adoptionFollowUp[column.field] && adoptionFollowUp[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );
    */

    const filteredAdoptionFollowUps = adoptionFollowUps.filter(adoptionFollowUp =>
      columns.some(column => {
          let value = adoptionFollowUp[column.field];
  
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
  
              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
              } catch(errr){}
          }
  
          return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
      })
    );


    setScheduled(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Scheduled'));
setCompleted(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Completed'));
setMissed(filteredAdoptionFollowUps.filter(cr => cr.followUpStatus === 'Missed'));


}, [searchTerm]);


  //USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setAdoptionColorMap(generateAdoptionColorMap(adoptionFollowUps, adoptionMap,theme));
setFollowUpStatusColorMap(generateFollowUpStatusColorMap(adoptionFollowUps,theme));
setContactMethodColorMap(generateContactMethodColorMap(adoptionFollowUps,theme));
setVolunteerColorMap(generateVolunteerColorMap(adoptionFollowUps, volunteerMap,theme));

}, [theme.palette.mode, adoptionFollowUps]);



  
 const formatAdoption = value => {

    let formattedAdoption = "";

    if (value != null && value !=="")
    {
    formattedAdoption = adoptionMap[value];
    }
    
    return formattedAdoption;
 };
    
                

 const formatVolunteer = value => {

    let formattedVolunteer = "";

    if (value != null && value !=="")
    {
    formattedVolunteer = volunteerMap[value];
    }
    
    return formattedVolunteer;
 };
    
                


   
  
  const moveCard = (item, toIndex, newFollowUpStatus) => {
    const fromList = getList(item.followUpStatus);
    const toList = getList(newFollowUpStatus);
    const [movedCard] = fromList.splice(item.index, 1);

    if (item.followUpStatus !== newFollowUpStatus) {
      movedCard.followUpStatus = newFollowUpStatus;
      toList.splice(toIndex, 0, movedCard);
    } else {
      fromList.splice(toIndex, 0, movedCard);
    }

    setList(item.followUpStatus, fromList);
    setList(newFollowUpStatus, toList);
    updateFollowUpStatus(movedCard, newFollowUpStatus);
  };

  const getList = (followUpStatus) => {
    switch (followUpStatus) {
      case 'Scheduled':
return scheduled;
case 'Completed':
return completed;
case 'Missed':
return missed;

      default:
        return [];
    }
  };

  const setList = (followUpStatus, list) => {
    switch (followUpStatus) {
      case 'Scheduled':
setScheduled(list);
case 'Completed':
setCompleted(list);
case 'Missed':
setMissed(list);

        break;
      default:
        break;
    }
  };

  const updateFollowUpStatus = (adoptionFollowUp, newFollowUpStatus) => {
    if (!adoptionFollowUp || !adoptionFollowUp.id) {
      console.error("Invalid change request: ", adoptionFollowUp);
      return;
    }

    const adoptionFollowUpRef = doc(db, "adoptionFollowUps", adoptionFollowUp.id);
    updateDoc(adoptionFollowUpRef, { followUpStatus: newFollowUpStatus })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  };


  const handleOpenModal = () => { setEditingAdoptionFollowUp(null); setShowModal(true); };
  
  const handleSaveAdoptionFollowUp = (adoptionFollowUp) => {
    if (editingAdoptionFollowUp && editingAdoptionFollowUp.id) {
      setAdoptionFollowUps(prevAdoptionFollowUps => prevAdoptionFollowUps.map(c => c.id === adoptionFollowUp.id ? adoptionFollowUp : c));
      saveAdoptionFollowUpToDB(adoptionFollowUp);
    } else {
      setAdoptionFollowUps(prevAdoptionFollowUps => [...prevAdoptionFollowUps, { ...adoptionFollowUp, id: prevAdoptionFollowUps.length + 1 }]);
      addAdoptionFollowUpToDB(adoptionFollowUp);
    }
    setShowModal(false);
    setEditingAdoptionFollowUp(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const saveAdoptionFollowUpToDB = async (adoptionFollowUp) => {
    const adoptionFollowUpRef = doc(db, "adoptionFollowUps", adoptionFollowUp.id);
    await updateDoc(adoptionFollowUpRef, adoptionFollowUp);
  };

  const addAdoptionFollowUpToDB = async (adoptionFollowUp) => {
    
    const adoptionFollowUpNumber= await generateUniqueId("adoptionFollowUps",appUserAccountNumber);
    adoptionFollowUp.adoptionFollowUpNumber = adoptionFollowUpNumber;

    adoptionFollowUp.appAccountNumber = appUserAccountNumber;
    adoptionFollowUp.applicationMode = applicationMode;

    const docRef = doc(db, 'adoptionFollowUps', adoptionFollowUpNumber);  
    await setDoc(docRef,adoptionFollowUp);

  };

  

  const handleDeleteSelected = async () => {
    if (deleteSelectionModel.length === 0) {
      setDeleteAlertOpen(true);
      return;
    } else 
    {

      setProcessing(true);
      const idsToDelete = [];
      const idsNotToDelete = [];

      let allDeletionDependencies = [];

      //1. Identify Ids to Delete
      for (const id of deleteSelectionModel)
      {
        const dependencies = await hasDependencies(id);
    
        allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

        setProcessing(false);
        
        if (dependencies.length === 0) {
          idsToDelete.push(id);
        } else 
        {
          idsNotToDelete.push(id);
        }
      }

      let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

      setDeletionDependencies(uniqueDeletionDependencies);

      setSelectedIdsToDelete(idsToDelete);
      setSelectedIdsNotToDelete(idsNotToDelete);

      //2. Delete allowed ids

      setDeleteConfirmOpen(true);
      setProcessing(false);

    }

  };


  const handleAlertClose = () => {
    setDeleteAlertOpen(false);
  };

  
  const handleCancelDelete = () => {
      
    setDeleteConfirmOpen(false);
    setSelectedIdsToDelete([]);
    setSelectedIdsNotToDelete([]);
    setDeletionDependencies([]);
    
};


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "adoptionFollowUps", id);
        batch.delete(docRef);
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  const openAdoptionFollowUpDrawer = (id) => {

    const rowIndex = filteredAdoptionFollowUps.findIndex(row => row.id === id);

    const adoptionFollowUpId = id;

    setSelectedRowIndex(rowIndex);

    const selectedAdoptionFollowUp = adoptionFollowUps.find(p => p.id === adoptionFollowUpId);
    if (selectedAdoptionFollowUp !== null && selectedAdoptionFollowUp != undefined)
    {  
      setSelectedAdoptionFollowUp(selectedAdoptionFollowUp);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedAdoptionFollowUp(null);
  };

  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "adoptionFollowUps", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const handleOpenEdit = (id) => {

    setEditingAdoptionFollowUp(adoptionFollowUps.find(adoptionFollowUp => adoptionFollowUp.id === id));
    setDrawerOpen(false);
    setShowModal(true); 
  }

  /*
  const filteredAdoptionFollowUps = adoptionFollowUps.filter(adoptionFollowUp =>
    columns.some(column => adoptionFollowUp[column.field] && adoptionFollowUp[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */
  
  const filteredAdoptionFollowUps = adoptionFollowUps.filter(adoptionFollowUp =>
    columns.some(column => {
        let value = adoptionFollowUp[column.field];

        if (column.field.endsWith('Id')) {
            const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

            try
            {
              value = eval(`${formatFunctionName}("${value}")`);
            } catch(errr){}
        }

        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    })
  );



  const totalAdoptionFollowUps = filteredAdoptionFollowUps.length;


  return (
    <div>
      
        <Box m="20px">
          <Header title="Adoption Follow Ups By Follow Up Status" subtitle="List of adoption follow ups" />
          <Box m="0px 0 0px 0" pt="10px" display="flex" >
          
            <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                  <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
                </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;

                <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                  <AddCircleOutlineIcon /> &nbsp; Add New
                </Button>
          </Box>
          {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress size={150} style={{ marginTop:'200px',color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
                </Box>
              ) : (
                <div>
                {adoptionFollowUps.length === 0 && (
                  
                  <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
                    <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
                    <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any adoption follow ups yet</Typography>
                    <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
                  </Box>
                
                )}

                {adoptionFollowUps.length > 0 && (
     
                <Box>
                {!isMobile ? (
     
                  <div>
                  
                  <div style={{ paddingTop:'7px',display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                   {/*   <div style={{ flex: '0 0 auto', textAlign: 'left', paddingLeft:'7px', fontSize:'11px' }}>
                          COLUMNS FILTERS
                      </div>
                    */}
                      <div style={{ margin: '0 auto', textAlign: 'center' }}>
                      You can drag and drop items from one column to the other
                      </div>
                  </div>
                  
                  <DndProvider backend={HTML5Backend}>
                    <Box display="flex" mt={1}>  {/* justifyContent="space-around" */}
                    
        <FollowUpStatusColumn
              title="Scheduled"
              followUpStatus="Scheduled"
              cards={scheduled}
              moveCard={moveCard} 
              setEditingAdoptionFollowUp={setEditingAdoptionFollowUp} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              adoptionFollowUps={adoptionFollowUps}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingAdoptionFollowUp} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              adoptionMap={adoptionMap}
formatAdoption={formatAdoption}
adoptionColorMap={adoptionColorMap}
contactMethodColorMap={contactMethodColorMap}
volunteerMap={volunteerMap}
formatVolunteer={formatVolunteer}
volunteerColorMap={volunteerColorMap}
followUpStatusColorMap={followUpStatusColorMap}

            />
        

        <FollowUpStatusColumn
              title="Completed"
              followUpStatus="Completed"
              cards={completed}
              moveCard={moveCard} 
              setEditingAdoptionFollowUp={setEditingAdoptionFollowUp} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              adoptionFollowUps={adoptionFollowUps}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingAdoptionFollowUp} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              adoptionMap={adoptionMap}
formatAdoption={formatAdoption}
adoptionColorMap={adoptionColorMap}
contactMethodColorMap={contactMethodColorMap}
volunteerMap={volunteerMap}
formatVolunteer={formatVolunteer}
volunteerColorMap={volunteerColorMap}
followUpStatusColorMap={followUpStatusColorMap}

            />
        

        <FollowUpStatusColumn
              title="Missed"
              followUpStatus="Missed"
              cards={missed}
              moveCard={moveCard} 
              setEditingAdoptionFollowUp={setEditingAdoptionFollowUp} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              adoptionFollowUps={adoptionFollowUps}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingAdoptionFollowUp} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              adoptionMap={adoptionMap}
formatAdoption={formatAdoption}
adoptionColorMap={adoptionColorMap}
contactMethodColorMap={contactMethodColorMap}
volunteerMap={volunteerMap}
formatVolunteer={formatVolunteer}
volunteerColorMap={volunteerColorMap}
followUpStatusColorMap={followUpStatusColorMap}

            />
        


                    </Box>
                  </DndProvider>
                  </div>

                ) : (    

                  <div className="tile-wrapper">

                  {filteredAdoptionFollowUps.slice(0, visibleCount).map((item, index) => ( 
                        <Tile key={index} data={item} adoptionFollowUps={adoptionFollowUps} setShowModal={setShowModal} setEditingData={setEditingAdoptionFollowUp} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
                       ))}
              
              
                  </div>

                )}
                </Box>

                )}
                

                </div>
            )}
        </Box>


        <AdoptionFollowUpDrawerModal
              drawerOpen={drawerOpen}
              handleDrawerClose={handleDrawerClose} 
              handleArrowUpClick="" 
              handleArrowDownClick=""
              selectedAdoptionFollowUp={editingAdoptionFollowUp}
              adoptionFollowUps={adoptionFollowUps} 
              handleOpenEdit={handleOpenEdit}
          />

      <AdoptionFollowUpInputModal isOpen={showModal} onClose={() => setShowModal(false)} onSave={handleSaveAdoptionFollowUp} adoptionFollowUp={editingAdoptionFollowUp} />

      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this adoption follow up?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected adoption follow ups? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected adoption follow ups with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining adoption follow ups with ids: &nbsp;
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>. <br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected adoption follow ups with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            {missingCollections.includes("adoptions") && <span>Please add at least one <b>adoption</b> before managing adoption follow ups. <br></br></span>}
{missingCollections.includes("volunteers") && <span>Please add at least one <b>volunteer</b> before managing adoption follow ups. <br></br></span>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No adoption follow ups selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This adoption follow up cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>
          Please remove these dependencies before proceeding with the deletion.
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
        <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
          {"Test Mode Notice"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText>
            You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
            <br /><br />
            If your intention is to add a live project record, please turn off test mode before proceeding.
          </DialogContentText>
          <Box mt={2}>
            <label>
              <input
                type="checkbox"
                checked={suppressTestModeWarning}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSuppressTestModeWarning(checked);
                  localStorage.setItem('suppressTestModeSaveWarning', checked);
                }}
              />{" "}
              Don't show this message again when saving in test mode
            </label>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button
            onClick={() => setShowTestModeDialog(false)}
            sx={{
              backgroundColor: colors.greenAccent[600],
              color: colors.primary[100],
              '&:hover': { backgroundColor: colors.greenAccent[800] }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


    {processing && (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex={2000}
      pointerEvents="none"
    >
      <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
    </Box>
  )}

    </div>

  );
};

const FollowUpStatusColumn = ({ title, followUpStatus, cards, moveCard, setEditingAdoptionFollowUp, setDeleteId, setConfirmOpen, adoptionFollowUps, setShowModal, colors, theme,deleteSelectionModel,setDeleteSelectionModel,titleColor,setEditingData,handleDeleteSingleItem,setDrawerOpen ,adoptionMap, formatAdoption,adoptionColorMap,followUpStatusColorMap,contactMethodColorMap,volunteerMap, formatVolunteer,volunteerColorMap}) => {
  const [, drop] = useDrop({
    accept: ItemType.CARD,
    drop: (item) => {
      moveCard(item, cards.length, followUpStatus);
    },
  });

  return (
    <Box
    ref={drop}
    sx={{ width: '30%', minHeight: '400px', backgroundColor: colors.dragAndDropDrop.droppableAreaBackgroundColor, padding: 0, marginBottom: 5, borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px', marginRight:2 }}
  >
    <Box 
      sx={{
        backgroundColor: titleColor === '#000000' ?  stringToColorLight(title) : titleColor,
        color: titleColor === '#000000' ? '#000000' : '#FFFFFF',
        padding: '0px',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        marginBottom: '10px',
        marginTop: '0px',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'center',
        minHeight:'45px',
        paddingTop:'10px'
      }}
    >
      <Typography variant="h5" style={{fontWeight:'600',fontSize:'17px'}}>{title} ({cards.length})</Typography>
    </Box>
      {cards.map((card, index) => (
        <DraggableCard
          key={card.id}
          adoptionFollowUp={card}
          index={index}
          moveCard={(from, to) => moveCard(from, to, followUpStatus)}
          followUpStatus={followUpStatus} 
          setEditingAdoptionFollowUp={setEditingAdoptionFollowUp} 
          setDeleteId={setDeleteId} 
          setConfirmOpen={setConfirmOpen} 
          adoptionFollowUps={adoptionFollowUps} 
          setShowModal={setShowModal} 
          colors={colors} 
          theme={theme} 
          deleteSelectionModel={deleteSelectionModel} 
          setDeleteSelectionModel={setDeleteSelectionModel} 
          setEditingData={setEditingData} 
          handleDeleteSingleItem={handleDeleteSingleItem}
          setDrawerOpen={setDrawerOpen}
          adoptionMap={adoptionMap}
formatAdoption={formatAdoption}
adoptionColorMap={adoptionColorMap}
followUpStatusColorMap={followUpStatusColorMap}
contactMethodColorMap={contactMethodColorMap}
volunteerMap={volunteerMap}
formatVolunteer={formatVolunteer}
volunteerColorMap={volunteerColorMap}

        />
      ))}
    </Box>
  );
};


export default AdoptionFollowUps;
